import 'css-chunksrc/client/scenes/resourcesListingConfiguration/styles.scss';export default {
  "resourcesListingConfiguration": "_resourcesListingConfiguration_95vlo_1",
  "main": "_main_95vlo_8",
  "tabs": "_tabs_95vlo_14",
  "tab": "_tab_95vlo_14",
  "selectedTab": "_selectedTab_95vlo_34",
  "label": "_label_95vlo_41",
  "footer": "_footer_95vlo_48",
  "button": "_button_95vlo_63"
};